<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row" style="display: flex !important;">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
            placeholder="{{ messageService.get_search() }}" autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div class="service_pager">
            <span>
                <div class="video_div1" (click)="open_video()" *ngIf="video">
                    <mat-icon class="video">smart_display</mat-icon>
                </div>
                <button class="new1" (click)='open_detaile(0,1,0)' [disabled]='new_status'>
                    <span>{{ messageService.get_new() }}</span>
                </button>
                <button class="search1" (click)='open_detaile(0,3,0)'>
                    <span>{{ messageService.get_filter() }}</span>
                </button>
                <button class="hidden-xs" *ngIf="level == 1" (click)="load_data3()"
                    [ngClass]="{active1:navigate == true}">-</button>
                <button class="hidden-xs" (click)="load_data2('all')" [ngClass]="{active1:available == 'all'}"> {{
                    messageService.get_all()}}</button>
                <button class="hidden-xs" (click)="load_data2('available')"
                    [ngClass]="{active1:available == 'available'}">
                    <span>موجودی</span>
                </button>
                <button class="hidden-xs" (click)="load_data2('unavailable')"
                    [ngClass]="{active1:available == 'unavailable'}">
                    <span>ناموجود</span>
                </button>

                <div class="pager_pe">
                    <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-fast-forward"></i></button>
                    <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-forward"></i></button>
                    <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-backward"></i></button>
                    <button (click)="check_access(4,5,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-fast-backward"></i></button>
                </div>
                <div class='navigation'><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
        <div class="pager_checkbox">
            <div class="pager_icon_en">
                <div class="excel">
                    <img src="../../../../../assets/images/excel.png" class="excel_icon cursor"
                        (click)="load_data(1,2,1,-1)">
                    <a href="" id="excel"><i class="far fa-file-excel" [hidden]="true"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content-body control-content-body" (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" style='min-width:100%' class='table-scroll mat_table_fa_without_scroll pe1'>

        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:45px'
                (click)="reset_sort('wharehouse_material_id','desc')">
                <span>#</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:45px'>{{ i +
                page_number_first }}</mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width:40px"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef style="min-width:350px"
                [ngClass]="{active1:order == 'wharehouse_material_title ' + asc_desc }"
                (click)="sort('wharehouse_material_title',asc_desc)">
                <span>عنوان کالا</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="min-width:350px">
                <div class="right">
                    <span (click)="open_detaile(i,2,x.wharehouse_material_id)">
                        {{x.wharehouse_material_title | substr:0:100 }}
                    </span>
                    <span style="float: left;" [matMenuTriggerFor]="menu"
                        (click)="open_report(x.wharehouse_material_id)"><i class="fas fa-info-circle icon"></i></span>
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="min-width:350px"></mat-footer-cell>
        </ng-container>
        <mat-menu #menu="matMenu" class="material-mat-menu-panel" xPosition="before">
            <div class="div_loading">
                <div class="my-container" [hidden]="!loading2">
                    <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
                </div>
            </div>
            <table class="table table-bordered" (click)="$event.stopPropagation()">
                <tr>
                    <td class="right">
                        <span (click)="open_serial(material_id)" class="cursor fright">
                            <span> افزودن سریالها </span>
                        </span>
                    </td>
                    <td> - </td>
                </tr>
                <tr>
                    <td class="right">
                        <span (click)="cardex(material_id)" class="cursor"> کاردکس کل </span>
                    </td>
                    <td> - </td>
                </tr>
                <tr>
                    <td class="right">
                        <span (click)="cardex_order(material_id)" class="cursor"> کاردکس گردش موجودی اول دوره </span>
                    </td>
                    <td> - </td>
                </tr>
                <tr>
                    <td class="right">
                        <span> موجودی اول دوره </span>
                    </td>
                    <td> {{ inventory }} </td>
                </tr>
                <tr>
                    <td class="right">
                        <span> فاکتور خرید </span>
                    </td>
                    <td> {{ invoice_buy }} </td>
                </tr>
                <tr>
                    <td class="right">
                        <span> مصرف شده در تعمیرگاه </span>
                    </td>
                    <td> {{ consumed_reception}} </td>
                </tr>
                <tr>
                    <td class="right">
                        <span> فاکتور فروش</span>
                    </td>
                    <td>{{ invoice_sale }}</td>
                </tr>
            </table>
        </mat-menu>

        <ng-container matColumnDef="inventory">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'inventory ' + asc_desc }"
                (click)="sort('inventory',asc_desc)" style="max-width: 120px;">
                <span>موجودی</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="update_inventory(i)" style="max-width: 120px;">
                <span *ngIf="x.inventory_loading == false">{{ x.inventory || 0 }}</span>
                <div class="spinner-border spinner-border-sm" role="status" *ngIf="x.inventory_loading == true">
                    <span class="sr-only">Loading...</span>
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="padding-left: 1.2rem !important;" style="max-width: 120px;">
                {{ sum_inventory
                | number }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="group">
            <mat-header-cell *matHeaderCellDef style="min-width: 100px;max-width: 280px;"
                [ngClass]="{active1:order == 'wharehouse_group_title ' + asc_desc }"
                (click)="sort('wharehouse_group_title',asc_desc)">
                <span>گروه</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_material_id)"
                style="min-width: 100px;max-width: 280px;">
                <div class="right">{{x.wharehouse_group_title }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="min-width: 100px;max-width: 280px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="cate">
            <mat-header-cell *matHeaderCellDef style="min-width: 100px;max-width: 280px;"
                [ngClass]="{active1:order == 'wharehouse_material_cate_title ' + asc_desc }"
                (click)="sort('wharehouse_material_cate_title',asc_desc)">
                <span>زیرگروه</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_material_id)"
                style="min-width: 100px;max-width: 280px;">
                <div class="right"> {{x.wharehouse_material_cate_title |
                    substr:0:20 }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="min-width: 100px;max-width: 280px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="code">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'wharehouse_material_coding ' + asc_desc }"
                (click)="sort('wharehouse_material_coding',asc_desc)" style="max-width: 120px;">
                <span>کد کالا</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_material_id)"
                style="max-width: 120px;">
                <div> {{x.wharehouse_material_coding || '-' }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width: 120px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="operation">
            <mat-header-cell *matHeaderCellDef style='max-width:50px'>
                <span> عملیات </span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:50px'>
                <span (click)="check_access(3,0,x.wharehouse_material_id,0,1)"><i class="far fa-trash-alt icon"
                        style='margin:0px 4px;'></i></span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width: 50px;"></mat-footer-cell>
        </ng-container>

        <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
        </mat-header-row>
        <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
            (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
            [ngClass]="{'mat_table_selected': row === mat_table_selectedRow || i == back_i,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor"></mat-row>
        <mat-footer-row style="background: rgb(245 245 163) !important;bottom:-2px"
            *matFooterRowDef="displayedColumns;sticky : true">
        </mat-footer-row>

    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets/images/preview.png">
            </div>
            <div class="preview2">{{ messageService.get_no_record_text() }}</div>
        </div>
    </div>
</div>